import { savedOrderDetailsActionButtonsStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons";
import { savedOrderDetailsCartLineStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsCartLine";
import { savedOrderDetailsProductListStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsProductList";
import { savedOrderListHeaderStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListHeader";
import { savedOrderListTableStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListTable";
import { StyledButton } from "@insite/mobius/Clickable";
import DataTableCellBase from "@insite/mobius/DataTable/DataTableCellBase";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

savedOrderDetailsProductListStyles.wrapper = {
    css: css`
        border-top: none;
    `,
}

savedOrderDetailsCartLineStyles.savedOrderLineInfoGridItem = {
    width: [12, 12, 10, 10, 10],
    printWidth: 11,
    css: css`
    ${({ theme }: { theme: BaseTheme }) =>
    breakpointMediaQueries(theme, [
        null,
        css`
        padding: 0px 15px;
        `,
        null,
        null,
        null,
    ],"max",)}
    `,
}

savedOrderDetailsCartLineStyles.productImageGridItem = {
    width: [12, 12, 2, 2, 2],
    printWidth: 1,
    css: css`
        padding: 0px 15px;
        justify-content: center;
        @media print {
            max-height: 83px;
            max-width: 83px;
            padding: 0;
        }
    `,
}

savedOrderDetailsCartLineStyles.priceGridItem = {
    width: [12, 12, 12, 4, 4],
    printWidth: 4,
    css: css`
        flex-direction: column;
        >section[class^="sc"] {
            >${TypographyStyle}{
                padding: 0;
                font-size: 14px;
                color: ${getColor("secondary")};
            }
        }
    `,
}



savedOrderDetailsCartLineStyles.quantityGridItem = {
    width: [2, 2, 2, 1, 1],
    css: css`
    >div[class^="sc"] {
        >${TypographyStyle}{
            color: ${getColor("secondary")};
            &:first-child{
                font-size: 14px;
            }
        }
    }
    `
}

savedOrderDetailsCartLineStyles.extendedUnitNetPriceGridItem = {
    width: [4, 4, 4, 3, 3],
    css: css`
        flex-direction: column;
        >div[class^="sc"] {
            >${TypographyStyle}{
                color: ${getColor("secondary")};
                &:first-child{
                    font-size: 14px;
                }
            }
        }
    `,
}

savedOrderDetailsCartLineStyles.productPrice = {
    price: {
        priceText: {
            weight: "bold",
            size: 16,
            css: css`
            color: ${getColor("secondary")};
            `
        },
    },
    secondaryPrice: {
        priceText: {
            weight: "normal",
            size: 16,
            css: css`
            color: ${getColor("secondary")};
            `
        },
    },
}

savedOrderDetailsCartLineStyles.productAvailabilityGridItem = {
    width: 12,
    css: css`
    >${GridWrapper}{
        >${GridOffset}{
            >${GridItemStyle}{
                >${StyledButton}{
                    >${TypographyStyle}{
                        font-size: 14px;
                    }
                }
                div{
                    >${TypographyStyle}{
                        font-size: 14px;
                    }
                }
            }
        }
    }
    `
}

savedOrderDetailsCartLineStyles.productBrandAndDescriptionGridItem = {
    css: css`
        flex-direction: column;
        >${StyledButton}{
            &:hover{
                text-decoration: underline;
            }
            >${TypographyStyle}{
                font-size: 1rem;
                font-weight: 500;
                color: ${getColor("secondary")};
            }
        }
    `,
    width: 12,
}

savedOrderDetailsCartLineStyles.container = {
    gap: 20,
    css: css`
        border: 1px solid ${getColor("common.border")};
        margin-bottom: 15px;
        padding: 1rem 0;
        >${GridOffset}{
            width: 100%;
            margin: 0;
        }
    `,
}

savedOrderDetailsActionButtonsStyles.printButton = {
    variant: "secondary",
    buttonType: "outline",
}

savedOrderListTableStyles.dataTableHead = {
    css: css`
        >${DataTableCellBase}{
            border-bottom: 1px solid ${getColor("common.border")};
            background: ${getColor("info.contrast")};
            >${StyledButton}{
                >${TypographyStyle}{
                    font-size: 16px;
                    color: ${getColor("primary")};
                }
                ${IconWrapper}{
                    color: ${getColor("primary")};
                }
            }
        }
    `
}

savedOrderListTableStyles.dataTableRow = {
    css: css`
        >${DataTableCellBase}{
            >${TypographyStyle}{
                font-size: 16px;
                color: ${getColor("secondary")};
            }
        }
    `
}

savedOrderListHeaderStyles.toggleFilterIcon = {
    src: "Filter",
    size: 24,
    css: css`
        color: ${getColor("primary")};
    `,
}